import { Component } from '@angular/core'
import { NgStyle } from '@angular/common'
import { CardComponent } from '@ui/Components/Card/Card.Component'
import { CardContentComponent } from '@ui/Components/Card/CardContent.Component'
import { RegisterFormComponent } from '@account/Components/Auth/Register/Form/RegisterForm.Component'

@Component({
	selector: 'register-component',
	templateUrl: './Register.Component.html',
	styleUrls: ['../Auth.css'],
	imports: [
		NgStyle,
		CardComponent,
		CardContentComponent,
		RegisterFormComponent,
	],
})
export class RegisterComponent {
	public onRegisterSuccessful = () => {
		window.location.reload()
	}
}
